import { ZodObject, ZodRawShape, z } from 'zod'

import { createTranslations } from '@/app/module/campaigns/types/schemas/common'
import ZTextContent from '@/app/module/campaigns/types/schemas/message-content/text'
import {
  ZWAAudioContent,
  ZWADocumentContent,
  ZWAImageContent,
  ZWAVideoContent,
} from '@/app/module/campaigns/types/schemas/message-content/whatsapp'

import ZBaseAction from './base'

const createSendWAContent = <Content extends ZodRawShape>(content: ZodObject<Content>) =>
  content.extend({
    registerTemplate: z.boolean().optional(),
    senderId: z.string(),
    useCampaignSenderId: z.string(),
    translations: createTranslations(content).nullable().optional(),
  })

const ZSendWAAudio = createSendWAContent(ZWAAudioContent)
const ZSendWADocument = createSendWAContent(ZWADocumentContent)
const ZSendWAImage = createSendWAContent(ZWAImageContent)
const ZSendWAText = createSendWAContent(ZTextContent)
const ZSendWAVideo = createSendWAContent(ZWAVideoContent)

const ZSendWhatsappAction = ZBaseAction.extend({
  sendWhatsapp: z.union([ZSendWAAudio, ZSendWADocument, ZSendWAImage, ZSendWAText, ZSendWAVideo]),
})

export default ZSendWhatsappAction
